<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <LoadingComponent :loading="loading" :message="loadingMessage" style="z-index: 1000;"></LoadingComponent>

    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <merus-data-table :headers="headers" :items="checklists" :loading="loadingtable" :default-multi-sort="defaultSort"
      :loading-text="$t('system.messages.loading')"

 cod-tabela="CADASTROCHECKLISTEQUIPAMENTO" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('equipmentChecklist.title')" :token="token" :items="checklists"
          :csv-title="$t('equipmentChecklist.title')" :pdf-title="$t('equipmentChecklist.title')" :pdf-headers="headers"
          :pdf-filename="$t('equipmentChecklist.title')" hide-search>
          <template v-slot:add>
            <v-dialog v-model="dialog" fullscreen max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar dark color="primary">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <!-- Basic Information -->
                      <v-card style="margin-bottom: 15px;">
                        <v-card-title style="color: #4a4a4a;">{{ $t('equipmentChecklist.basicInfo') }}</v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                v-model="editedItem.nome_checklist"
                                :label="$t('equipmentChecklist.name')"
                                outlined
                                :rules="[validaCampo]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-textarea
                                v-model="editedItem.descricao"
                                outlined
                                rows="2"
                                :label="$t('equipmentChecklist.description')"
                                counter
                                maxlength="500"
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete
                                v-model="editedItem.id_servicos"
                                :items="servicos"
                                item-text="nome_servico"
                                item-value="id_servico"
                                :label="$t('equipmentChecklist.services')"
                                outlined
                                multiple
                                chips
                                small-chips
                                deletable-chips
                                clearable
                                :menu-props="{ maxHeight: 300 }"
                              >
                                <template v-slot:selection="{ item }">
                                  <v-chip small>{{ item.nome_servico }}</v-chip>
                                </template>
                                <template v-slot:item="{ item }">
                                  <span>{{ item.nome_servico }}</span>
                                  <v-spacer></v-spacer>
                                  <span class="caption grey--text">{{ item.nome_tipo_atendimento }}</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-switch
                                v-model="editedItem.associado_veiculo"
                                :label="$t('equipmentChecklist.associatedWithVehicle')"
                                color="primary"
                                hide-details
                              ></v-switch>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>

                      <!-- Checklist Fields -->
                      <v-card style="margin-bottom: 15px;">
                        <v-card-title style="color: #4a4a4a;">
                          {{ $t('equipmentChecklist.fields') }}
                          <v-spacer></v-spacer>
                          <v-btn color="primary" small @click="addField">
                            <v-icon left>mdi-plus</v-icon>
                            {{ $t('equipmentChecklist.addField') }}
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-row v-for="(field, index) in editedItem.campos" :key="index" style="margin-bottom: 10px;">
                            <v-col cols="12" sm="12" md="3">
                              <v-text-field
                                v-model="field.label"
                                :label="$t('equipmentChecklist.fieldLabel') + ' *'"
                                outlined
                                dense
                                :rules="[validaCampo]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="2">
                              <v-select
                                v-model="field.tipo"
                                :items="fieldTypes"
                                :label="$t('equipmentChecklist.fieldType') + ' *'"
                                outlined
                                dense
                                :rules="[validaCampo]"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="2" v-if="field.tipo === 'Select'">
                              <v-text-field
                                v-model="field.opcoes"
                                :label="$t('equipmentChecklist.options')"
                                outlined
                                dense
                                hint="Separar por vírgula"
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="2">
                              <v-checkbox
                                v-model="field.obrigatorio"
                                :label="$t('equipmentChecklist.required')"
                                dense
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="12" md="2">
                              <v-checkbox
                                v-model="field.ativo"
                                :label="$t('equipmentChecklist.active')"
                                dense
                                :value="field.ativo !== false"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="12" md="1">
                              <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                                <v-btn 
                                  icon 
                                  color="primary" 
                                  @click="moveFieldUp(index)" 
                                  small
                                  :disabled="index === 0"
                                  title="Mover para cima"
                                >
                                  <v-icon>mdi-arrow-up</v-icon>
                                </v-btn>
                                <v-btn 
                                  v-if="index !== editedItem.campos.length - 1"
                                  icon 
                                  color="primary" 
                                  @click="moveFieldDown(index)" 
                                  small
                                  title="Mover para baixo"
                                >
                                  <v-icon>mdi-arrow-down</v-icon>
                                </v-btn>
                                <v-btn 
                                  v-else
                                  icon 
                                  color="primary" 
                                  @click="addField" 
                                  small
                                  title="Adicionar novo campo"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                                <v-btn 
                                  icon 
                                  color="primary" 
                                  @click="duplicateField(index)" 
                                  small
                                  title="Duplicar campo"
                                >
                                  <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon color="red" @click="removeField(index)" small title="Remover campo">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                          <v-alert v-if="editedItem.campos.length === 0" type="info" outlined>
                            {{ $t('equipmentChecklist.noFields') }}
                          </v-alert>
                        </v-card-text>
                      </v-card>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.dt_inclusao_extenso="{ item }">
        {{ item.dt_inclusao_extenso || '-' }}
      </template>
      <template v-slot:item.nome_usuario="{ item }">
        {{ item.nome_usuario || '-' }}
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import LoadingComponent from '../LoadingComponent.vue';
import MerusDataTable from "../Tables/MerusDataTable.vue";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue";
import EventBus from "@/utils/eventBus";

export default {
  components: {
    LoadingComponent,
    MerusDataTable,
    CadastroToolbar
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    loading: false,
    loadingMessage: "",
    loadingtable: true,
    showConfirmButton: true,
    formValidado: false,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    checklists: [],
    editedIndex: -1,
    servicos: [],
    editedItem: {
      id_checklist: null,
      nome_checklist: null,
      descricao: null,
      id_tipo_equipamento: null,
      id_tipo_kit: null,
      id_perfil_usuario: null,
      id_servicos: [],
      associado_veiculo: false,
      campos: []
    },
    deletedItem: {
      id_checklist: null,
      nome_checklist: null
    },
    defaultItem: {
      id_checklist: null,
      nome_checklist: null,
      descricao: null,
      id_tipo_equipamento: null,
      id_tipo_kit: null,
      id_perfil_usuario: null,
      id_servicos: [],
      associado_veiculo: false,
      campos: []
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 
        ? this.$t('equipmentChecklist.registerChecklist') 
        : this.$t('equipmentChecklist.editChecklist');
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
    defaultSort() {
      return [
        { value: 'dt_inclusao', options: { text: this.$t('routs.decreasing'), value: -1 } }];
    },
    fieldTypes() {
      return [
      { text: this.$t('equipmentChecklist.selectOptions.text'), value: 'Text' },
      { text: this.$t('equipmentChecklist.selectOptions.number'), value: 'Number' },
      { text: this.$t('equipmentChecklist.selectOptions.date'), value: 'Date' },
      { text: this.$t('equipmentChecklist.selectOptions.select'), value: 'Select' },
      { text: this.$t('equipmentChecklist.selectOptions.checkbox'), value: 'Checkbox' },
      { text: this.$t('equipmentChecklist.selectOptions.textarea'), value: 'Textarea' },
      { text: this.$t('equipmentChecklist.selectOptions.photo'), value: 'Photo' }
    ];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  methods: {

    validaCampo(v) {
      return !!v || this.$t('validation.required');
    },
    initialize() {
      this.populaChecklists();
      this.populaServicos();
    },
    populaServicos() {
      apiController.request(apiController.endpoints.getallServicos, {
        onSuccess: (response) => {
          this.servicos = response.data || [];
        },
      });
    },
    populaChecklists() {
      this.loadingtable = true;
      // Load checklists from the last year to current date
      const today = new Date();
      const startDate = new Date(today.getFullYear() - 1, today.getMonth(), 1).toISOString().split('T')[0];
      const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
      
      apiController.request(apiController.endpoints.getChecklistsequipamentospordata, {
        params: { dti: startDate, dtf: endDate },
        onSuccess: (response) => {
          this.checklists = response.data || [];
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    addField() {
      this.editedItem.campos.push({
        label: '',
        tipo: 'Text',
        obrigatorio: false,
        ativo: true,
        opcoes: ''
      });
    },
    removeField(index) {
      this.editedItem.campos.splice(index, 1);
    },
    duplicateField(index) {
      const field = this.editedItem.campos[index];
      const copy = {
        label: field.label ? `${field.label} (cópia)` : '',
        tipo: field.tipo || 'Text',
        obrigatorio: field.obrigatorio || false,
        ativo: field.ativo !== false,
        opcoes: field.opcoes != null ? field.opcoes : ''
      };
      this.editedItem.campos.splice(index + 1, 0, copy);
      this.$set(this.editedItem, 'campos', [...this.editedItem.campos]);
    },
    moveFieldUp(index) {
      if (index > 0) {
        const campos = this.editedItem.campos;
        const temp = campos[index];
        campos[index] = campos[index - 1];
        campos[index - 1] = temp;
        // Force reactivity update
        this.$set(this.editedItem, 'campos', [...campos]);
      }
    },
    moveFieldDown(index) {
      if (index < this.editedItem.campos.length - 1) {
        const campos = this.editedItem.campos;
        const temp = campos[index];
        campos[index] = campos[index + 1];
        campos[index + 1] = temp;
        // Force reactivity update
        this.$set(this.editedItem, 'campos', [...campos]);
      }
    },
    editItem(item) {
      this.loading = true;
      this.loadingMessage = this.$t('system.messages.loading');
      // Fetch full checklist with fields
      apiController.request(apiController.endpoints.getChecklistequipamentoporid, {
        params: { id: item.id_checklist },
        onSuccess: (response) => {
          this.loading = false;
          if (response.data && !response.data.erro) {
            const checklist = response.data;
            this.editedIndex = this.checklists.indexOf(item);
            // Convert opcoes from array to comma-separated string for display
            // Sort by ordem to ensure correct field order
            const campos = (checklist.campos || [])
              .sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
              .map(campo => ({
                ...campo,
                opcoes: campo.tipo === 'Select' && campo.opcoes && Array.isArray(campo.opcoes) 
                  ? campo.opcoes.join(', ') 
                  : (campo.opcoes || '')
              }));
            const idChecklist = checklist.id_checklist || checklist.id_checklist_equipamento;
            const idServicos = (this.servicos || [])
              .filter(s => String(s.id_checklist_equipamento) === String(idChecklist))
              .map(s => s.id_servico);
            this.editedItem = {
              id_checklist: idChecklist,
              nome_checklist: checklist.nome_checklist,
              descricao: checklist.descricao || '',
              id_tipo_equipamento: null,
              id_tipo_kit: null,
              id_perfil_usuario: null,
              id_servicos: idServicos,
              associado_veiculo: !!(checklist.associado_veiculo == null ? false : checklist.associado_veiculo),
              campos: campos
            };
            this.dialog = true;
          } else {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.loadError'),
              tipo: 'error'
            });
          }
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    deleteItem(item) {
      this.deletedItem = {
        id_checklist: item.id_checklist,
        nome_checklist: item.nome_checklist
      };
      this.mensagemdialog = this.$t('equipmentChecklist.confirmDelete', { name: item.nome_checklist });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      this.loading = true;
      this.loadingMessage = this.$t('system.messages.deleting');
      
      apiController.request(apiController.endpoints.deleteChecklistequipamento, {
        params: { id: this.deletedItem.id_checklist },
        onSuccess: (response) => {
          this.loading = false;
          if (response.data.erro) {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.deleteError'),
              tipo: 'error'
            });
          } else {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipmentChecklist.deleteSuccess'),
              tipo: 'success'
            });
            this.populaChecklists();
          }
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        // Validate that at least one field exists
        if (!this.editedItem.campos || this.editedItem.campos.length === 0) {
          EventBus.$emit('show-alert', {
            mensagem: this.$t('equipmentChecklist.atLeastOneField'),
            tipo: 'warning'
          });
          return;
        }

        // Validate all fields have labels
        const invalidFields = this.editedItem.campos.filter(f => !f.label || !f.tipo);
        if (invalidFields.length > 0) {
          EventBus.$emit('show-alert', {
            mensagem: this.$t('equipmentChecklist.invalidFields'),
            tipo: 'warning'
          });
          return;
        }

        // Prepare campos data - convert opcoes from comma-separated string to array
        const campos = this.editedItem.campos.map((field, index) => {
          const campoData = {
            label: field.label,
            tipo: field.tipo,
            obrigatorio: field.obrigatorio || false,
            ativo: field.ativo !== false,
            ordem: index
          };
          // Convert opcoes from comma-separated string to array for Select type
          if (field.tipo === 'Select' && field.opcoes) {
            campoData.opcoes = typeof field.opcoes === 'string' 
              ? field.opcoes.split(',').map(o => o.trim()).filter(o => o.length > 0)
              : (Array.isArray(field.opcoes) ? field.opcoes : []);
          }
          return campoData;
        });

        const isEdit = this.editedIndex >= 0 && this.editedItem.id_checklist;
        const userId = (typeof this.user === 'object' && this.user.id_usuario) ? this.user.id_usuario : this.user;
        
        const payload = {
          nome_checklist: this.editedItem.nome_checklist,
          descricao: this.editedItem.descricao || null,
          id_tipo_equipamento: null,
          id_tipo_kit: null,
          id_perfil_usuario: null,
          id_servicos: Array.isArray(this.editedItem.id_servicos) ? this.editedItem.id_servicos : [],
          associado_veiculo: !!this.editedItem.associado_veiculo,
          campos: campos
        };

        // Add user fields based on operation type
        if (isEdit) {
          payload.id_usuario_alteracao = userId;
        } else {
          payload.id_usuario_inclusao = userId;
        }

        this.loading = true;
        this.loadingMessage = this.$t('system.messages.saving');

        const onSuccess = (response) => {
            this.loading = false;
            if (response.data.erro) {
              EventBus.$emit('show-alert', {
                mensagem: this.$t('equipmentChecklist.saveError'),
                tipo: 'error'
              });
            } else {
              EventBus.$emit('show-alert', {
                mensagem: this.$t('equipmentChecklist.saveSuccess'),
                tipo: 'success'
              });
              this.close();
              this.populaChecklists();
            }
        };
        const onError = () => {
            this.loading = false;
        };

        if (isEdit) {
          apiController.request(apiController.endpoints.updateChecklistequipamento, {
            params: { id: this.editedItem.id_checklist },
            data: payload,
            onSuccess,
            onError,
          });
        } else {
          apiController.request(apiController.endpoints.insertChecklistequipamento, {
            data: payload,
            onSuccess,
            onError,
          });
        }
      }
    }
  }
};
</script>

<style scoped>
</style>

